import { BusinessGetResponseType } from "@sellar-io/api-v2/types";

import { type DeepKeys } from "@tanstack/react-form";

import { BusinessFormFieldValues } from "../business/BusinessFormValues";

import { OwnershipType } from "./BuyerBusinessOwnership";

export type BusinessFieldName = DeepKeys<BusinessFormFieldValues>;

export type BuyerFieldValues = {
  ownershipType: OwnershipType | undefined;
};

export const fieldName = (name: string) => name as BusinessFieldName;

export const generateBuyerFieldValues = (
  buyer?: BusinessGetResponseType["Retailer"],
): BuyerFieldValues => ({
  ownershipType: buyer?.ownershipType || undefined,
});
